/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorScorecardAttributeRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorScorecardAttributeRoute);
